export enum ApiMethod {
    Post = 'POST',
    Get = 'GET',
    Delete = 'DELETE',
    Put = 'PUT',
    Patch = 'PATCH',
}

export enum ApiContentType {
    ApplicationXWWWFormUrlencoded = 'application/x-www-form-urlencoded',
    ApplicationJSON = 'application/json',
    MultipartFormData = 'multipart/form-data',
}

export type ApiHeaders = {
    'x-device-code': string
    'Content-Type': ApiContentType | undefined
}
